export const isInAppBrowser = (): boolean => {
  if (typeof window === 'undefined') return false
  
  const userAgent = window.navigator.userAgent.toLowerCase()
  
  // Check for common in-app browser indicators
  return (
    userAgent.includes('wv') || // Android WebView
    userAgent.includes('instagram') ||
    userAgent.includes('fbav') || // Facebook
    userAgent.includes('twitter') ||
    userAgent.includes('line') ||
    userAgent.includes('linkedin') ||
    userAgent.includes('whatsapp') ||
    userAgent.includes('telegram')
  )
}